import { useLocalizationStore } from '@/stores/localizationStore';
import { useAuthStore } from '@/stores/authStore';
import { queryClient } from '@/lib/queryClient';

/**
 * Imperative translation lookup for use OUTSIDE React (interceptors, plain
 * helpers). Mirrors the `t()` returned by `useTranslation` — it reads the
 * same string bundle from the TanStack Query cache and falls back to the
 * supplied fallback, then the raw key.
 */
export function translate(key: string, fallback?: string): string {
  const language = useLocalizationStore.getState().language;
  const organizationId = useAuthStore.getState().session?.organization.id ?? '';
  const strings = queryClient.getQueryData<Record<string, string>>([
    'localization',
    'bundle',
    language,
    organizationId,
  ]);
  return strings?.[key] ?? fallback ?? key;
}
